import React from 'react';
import T from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


const defaultNavStyle = {
    // display: 'grid',
    // width: '100%',
    // marginTop: '1rem',
    // gridTemplateColumns: '1fr 1fr',
    // columnGap: '0.5rem'
}

const Tabs = ({
    index,
    sections,
    style= {},
    onChange
}) => {

    return (
        <div className="sections-header" style={{...defaultNavStyle, ...style}}>
          <T value={index} onChange={(e, i) => onChange(i)} variant="scrollable" >
            {sections.map(s => <Tab key={s.title} label={s.title} />)}
          </T>
        </div>
    )
};

export default Tabs;